export default __webpack_public_path__ + "static/media/rob-h.67983fa9.png";